import { render, staticRenderFns } from "./_dashboard.vue?vue&type=template&id=3289ef58&scoped=true"
import script from "./_dashboard.vue?vue&type=script&lang=js"
export * from "./_dashboard.vue?vue&type=script&lang=js"
import style0 from "./_dashboard.vue?vue&type=style&index=0&id=3289ef58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3289ef58",
  null
  
)

export default component.exports